import Vue from "vue";
import Vuex from "vuex";
import api_menu from "./modules/api_menu"
import posts from "./modules/posts";
import products from "./modules/products";
import births from "./modules/births";
import birthdays from "./modules/birthdays";
import surveys from "./modules/surveys";
import welcomes from "./modules/welcomes";
import searchs from "./modules/searchs";
import user from "./modules/user";
import menus from "./modules/menus";
import weather from "./modules/weather";
import benefits from "./modules/benefits";
import benefits_group from "./modules/benefits_group"
import galleries from "./modules/galleries"
import library from "./modules/library"
import links from "./modules/links";
import sections from "./modules/sections";
import comments from "./modules/comments";
import helpcenter from "./modules/helpcenter";
import protagonists from "./modules/protagonists";
import notifications from "./modules/notifications";
import advance_payments from "./modules/advance_payments";
import loading from "./modules/loading";

Vue.use(Vuex);

const filters = () => {
  return {
    query: ""
  };
};

export default new Vuex.Store({
  modules: {
    api_menu,
    posts,
    products,
    births,
    birthdays,
    surveys,
    welcomes,
    searchs,
    user,
    menus,
    benefits,
    benefits_group,
    weather,
    galleries,
    library,
    links,
    sections,
    comments,
    helpcenter,
    protagonists,
    notifications,
    advance_payments,
    loading
  },
  state: {
    headers: {},
    questions: [
      {
        question: "Tengo una duda de accidentes laborales",
        answer: "Prevención de Riesgos"
      },
      {
        question: "Necesito modificar mi anexo telefónico ",
        answer: "Ingreso a MiSecurity (EXA)	www.misecurity.cl"
      },
      {
        question: "Necesito recibir asesoría laboral",
        answer: "Relaciones Laborales: carolina.rojas@security.cl"
      },
      {
        question:
          "Tengo un problema con los Avisos Clasificados de la Intranet Corporativa",
        answer: "Comunicaciones:	intranet@security.cl"
      },
      {
        question:
          "Necesito información sobre las becas de estudio para hijos de empleados",
        answer: "Compensaciones:	beneficios@security.cl"
      },
      {
        question:
          "Necesito información sobre las becas de estudio para empleados",
        answer: "Formación:	formacion@security.cl"
      },
      {
        question: "Tengo dudas de mis beneficios",
        answer: "Compensaciones:	beneficios@security.cl"
      },
      {
        question: "Necesito información de las Cajas de Compensación ",
        answer: "Compensaciones: compensaciones@security.cl "
      },
      {
        question: "Tengo una duda de Capacitación ",
        answer: "Formación:	formacion@security.cl"
      },
      {
        question: "Necesito Certificados (Antigüedad, Renta, etc.)",
        answer: "Payroll:	consulta_security@adp.com"
      },
      {
        question:
          "Necesito Certificados (Nacimiento, Matrimonio, Estado Civil y Fallecimiento)",
        answer:
          "Loreto Prieto y Maite Marchant: loreto.prieto@security.cl y maite.marchant@security.cl"
      },
      {
        question: "Necesito hablar del Clima laboral",
        answer: "Clima y Cultura:	mariapaz.vallejos@security.cl"
      },
      {
        question: "Necesito cambiar mi computador",
        answer: "Jefatura Directa"
      },
      {
        question: "Mi computador está funcionando mal",
        answer: "Soporte: soporte@security.cl"
      },
      {
        question: "Tengo una consulta sobre Oportunidades Laborales",
        answer: "Selección: selección@security.cl"
      },
      {
        question: "Necesito información de los Contratos de trabajo",
        answer: "Administración de Personas: maite.marchant@security.cl"
      },
      {
        question: "Quiero saber qué convenios tenemos",
        answer: "Calidad de Vida: beneficios@security.cl"
      },
      {
        question: "No recibo los correos de Cultura Corporativa",
        answer: "Comunicaciones: intranet@security.cl"
      },
      {
        question: "Necesito una nueva Credencial",
        answer: "Loreto Prieto: loreto.prieto@security.cl"
      },
      {
        question: "Necesito acceder a los Créditos de la Banca Empleados",
        answer: "Carolina Frindt: carolina.frindt@security.cl"
      },
      {
        question: "Quiero referir un Curriculum Vitae",
        answer: "Selección: selección@security.cl"
      },
      {
        question: "Necesito información de los cursos disponibles",
        answer: "Formación: formacion@security.cl"
      },
      {
        question:
          "Necesito modificar los Datos del Cargo (empresa, cargo, dependencia, centro de costo, etc).",
        answer: "Compensaciones: compensaciones@security.cl"
      },
      {
        question: "Necesito modificar los Datos Laborales y Personales",
        answer: "MiSecurity (EXA): www.misecurity.cl"
      },
      {
        question: "Tengo dudas relacionadas a mi Desarrollo de Carrera",
        answer: "Desarrollo Organizacional: desarrollo@security.cl"
      },
      {
        question: "Necesito actualizar mi descripción de cargo",
        answer: "Desarrollo Organizacional: desarrollo@security.cl"
      },
      {
        question: "Quiero estudiar algo con apoyo de la empresa",
        answer: "Formación: formacion@security.cl"
      },
      {
        question: "Tengo sonsultas sobre las Evaluación de Desempeño",
        answer: "Desarrollo Organizacional: desarrollo@security.cl"
      },
      {
        question: "No puedo acceder a EXA",
        answer: "Soporte Exa: sporte@exa.cl"
      },
      {
        question: "Quiero actualizar mi foto de perfil",
        answer: "Administración de Personas: maite.marchant@security.cl"
      },
      {
        question: "Tengo una consulta sobre el Fun Friday´s ",
        answer: "Calidad de Vida: beneficios@security.cl"
      },
      {
        question: "Tengo una consulta sobre la Inducción Corporativa",
        answer: "Formación: formacion@security.cl"
      },
      {
        question: "Necesito publicar una noticia en la Intranet Corporativa",
        answer: "Comunicaciones: intranet@security.cl"
      },
      {
        question: "No puedo acceder a la Intranet Corporativa",
        answer: "Soporte: soporte@security.cl"
      },
      {
        question: "Tengo una consulta sobre las Licencias médicas",
        answer: "Payroll: consulta_security@adp.com"
      },
      {
        question: "Tengo una consulta sobre Movistar",
        answer: "Equipo Movistar: movistar@ext-security.cl"
      },
      {
        question:
          "Tengo una consulta sobre los permisos de Chequeos Médicos Preventivos",
        answer: "Administración de Personas: maite.marchant@security.cl"
      },
      {
        question:
          "Necesito ingresar una solicitud del permiso 24 horas para algo importante",
        answer: "MiSecurity (EXA): www.misecurity.cl"
      },
      {
        question:
          "Tengo una consulta sobre los Premios de Antigüedad y Espíritu",
        answer: "Clima y Cultura: mariapaz.vallejos@security.cl"
      },
      {
        question:
          "Necesito información sobre el status de un Procesos de Selección",
        answer: "MiSecurity (EXA): www.misecurity.cl"
      },
      {
        question: "Necesito información sobre las pruebas de ingreso",
        answer: "Selección: selección@security.cl"
      },
      {
        question: "Necesito solicitar un Puertas Abiertas",
        answer: "Relaciones Laborales: carolina.rojas@security.cl"
      },
      {
        question: "Necesito información sobre los seguros de Salud o Dental",
        answer: "Anita Alegre: anita.alegre@security.cl"
      },
      {
        question: "Necesito una nueva Tarjetas de ingreso",
        answer: "Administración (Alan Turner): alan.turner@security.cl"
      },
      {
        question: "Tengo una consulta sobre las Tarjetas de Trabajo Bien Hecho",
        answer: "Clima y Cultura: mariapaz.vallejos@security.cl"
      },
      {
        question: "Tengo una consulta sobre los uniformes",
        answer: "Administración (Jaime Pereda): jaime.pereda@security.cl"
      },
      {
        question: "Tengo una duda sobre mis vacaciones",
        answer: "Compensaciones: compensaciones@security.cl"
      },
      {
        question: "Quiero ingresar o proyectar mis vacaciones",
        answer: "MiSecurity: www.misecurity.cl"
      }
    ],
    filter: filters()
  },
  mutations: {
    setFilter(state, data) {
      state.filter[data["filter"]] = data.value;
    }
  },
  getters: {
    filteredAnswers(state) {
      let questions = state.questions;
      if (state.filter.query.length > 1) {
        questions = questions.filter(question =>
          question.question.toLowerCase().includes(state.filter.query)
        );
      }
      return questions;
    }
  }
});
